module.exports = __webpack_public_path__ + "img/toggle-sidebar-right.9c6c308e.svg";